import axios from 'axios'
import {getToken} from '@/api/common.js'

// axios.defaults.withCredentials=true

// 根据环境不同引入不同api地址
// create an axios instance
const service = axios.create({
  //baseURL: baseApi, // url = base api url + request url
  withCredentials: false, // send cookies when cross-domain requests
  timeout: 250000, // request timeout

  headers: {
    'Authorization': '5539403baad38e1818e5ec43a024416c',
	'token':getToken()
  }
})
// request拦截器 request interceptor
service.interceptors.request.use(
  config => {
    return config
  },
  error => {   
    return Promise.reject(error)
  }
)
// respone拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.msg === '用户未登录') {
      localStorage.removeItem('token')
      localStorage.removeItem('permiss')
this.$router.push({path:'/login'});

    }
    return Promise.resolve(res)
  },
  error => {  
    return Promise.reject(error)
  }
)


export default service
